import React, {SVGProps} from 'react';

import {ReactComponent} from '../../assets/svg/traffic-lamp-mobile.svg';

export default (props: SVGProps<any>): JSX.Element => <ReactComponent {...props} />;
